module.exports = __webpack_public_path__ + "img/rfile.15695e04.svg";